import Table, { TableConstructorOptions } from "cli-table3";

const DEFAULTS: TableConstructorOptions = {
  chars: {
    top: "─",
    "top-mid": "┬",
    "top-left": "┌",
    "top-right": "┐",
    bottom: "─",
    "bottom-mid": "┴",
    "bottom-left": "└",
    "bottom-right": "┘",
    left: "│",
    "left-mid": "├",
    mid: "─",
    "mid-mid": "┼",
    right: "│",
    "right-mid": "┤",
    middle: "│",
  },
  style: { "padding-left": 1, "padding-right": 1 },
};

const WITHOUT_BORDERS: TableConstructorOptions = {
  chars: {
    top: "",
    "top-mid": "",
    "top-left": "",
    "top-right": "",
    bottom: "",
    "bottom-mid": "",
    "bottom-left": "",
    "bottom-right": "",
    left: "",
    "left-mid": "",
    mid: "",
    "mid-mid": "",
    right: "",
    "right-mid": "",
    middle: " ",
  },
  style: { "padding-left": 2, "padding-right": 0, border: [], head: [] },
};

export function createTable(opts: TableConstructorOptions = {}) {
  return new Table({ ...DEFAULTS, ...opts });
}

export function createTableWithoutBorders(opts: TableConstructorOptions = {}) {
  return new Table({ ...WITHOUT_BORDERS, ...opts });
}
